module.exports = __webpack_public_path__ + "media/images/memes/success-kid-0650aee2701a720e1f2cee53fad3e7a0.gif";